import React from 'react'
import HeroSection from '../HeroSection'
import HomepageStuff from '../HomepageStuff'
import Footer from '../Footer'

export default function Home() {
  return (
    <>
      <HeroSection text2='Quantiq Financial' video='/videos/Q (Video) 2.mp4'/>
      <HomepageStuff/>
      <Footer />
    </>
    )
}
